module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-rondele-redondo-4b7f3f01c2fa35b664afd57faab091bf.jpg";